export default __webpack_public_path__ + "static/media/ig-comments.48591412.svg";